import axios from 'axios'

const API_PATH = 'api/v2/admins/sellers/products/commissions'

const SellerProductCommissionsApiV2 = {
  /**
   * Confirm Seller Price on Seller Product
   * @param {array} price_confirmations - List of price confirmations
   */
  get: async (params) => {
    const response = await axios.get(API_PATH, { params })
    return response
  },
  changeStatus: (commissionId, isActive) => {
    const params   = {
      commission_id : commissionId,
      is_active     : isActive
    }
    const path     = `${API_PATH}/change_status`
    const response = axios.patch(path, params)
    return response
  },
  create: (params) => {
    const response = axios.post(API_PATH, params)
    return response
  },
  update: (params) => {
    const response = axios.patch(API_PATH, params)
    return response
  }
}

export default SellerProductCommissionsApiV2